import styled from "styled-components/macro";
import {device} from "../../styles";

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 80px;

    ${device.less1180} {
        margin-top: 20px;
    }

    ${device.less768} {
        width: 100%;
        height: 62px;
        padding: 0 15px;
        margin-top: auto;
        border-top: 1px solid #e5e5e5;
        justify-content: center;
    }
`;

export const Body = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const Price = styled.div`
    flex: 1;
    font-family: 'Mazzard L', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 26px;
    color: var(--color-accent);
    text-transform: uppercase;
    padding-right: 30px;

    ${device.less1180} {
        font-size: 18px;
        padding: 0 20px;
    }

    ${device.less768} {
        font-size: 16px;
        line-height: 18px;
    }
`;

export const Action = styled.div``;
